import {createReducer, on} from '@ngrx/store';
import {appNavigationStateInitial} from './app-navigation.state.initial';
import {AppNavigationActions} from './app-navigation.actions';


export const appNavigationReducer = createReducer(
  appNavigationStateInitial,

  on(
    AppNavigationActions.enableButton,
    (state) => ({
      ...state,
      buttonEnabled: true,
    })
  ),

  on(
    AppNavigationActions.disableButton,
    (state) => ({
      ...state,
      buttonEnabled: false,
    })
  ),
);
